import styled from 'styled-components';
import size from '../../theme/mediaQueries';

const isDarkTheme = (theme: { colors: { text: string; white: string } }): boolean => (
  theme.colors.text === theme.colors.white
);

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 350px;
  height: 40px;
  color: ${(props) => props.theme.colors.text};
  z-index: 1;

  .search-container,
  .events-container {
    background-color: ${(props) => (
    isDarkTheme(props.theme) ? props.theme.colors.black : props.theme.colors.white
  )};
    box-shadow: ${(props) => props.theme.shadows.dropdown};
    border-radius: 12px;
    cursor: pointer;
  }
  
  .events-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 4px 16px;
    width: 294px;
    height: 40px;

    div {
      display: flex;
      align-items: center;

      p {
        font-size: 13px;
        padding-left: 4px;
      }

      .count {
        color: ${(props) => props.theme.colors.text};
      }

      .label {
        color: ${(props) => props.theme.colors.inactive};
      }
    }
    
    div:not(:last-of-type)::after {
      content: '';
      width: 0;
      height: 22px;
      margin-left: 16px;
      border-left: 1px solid ${(props) => props.theme.colors.outline};
    }
  }
  
  .search-container {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  @media (min-width: ${size.laptopS}){
    position: fixed;
    left:  calc(55% - 175px);
  }

  @media(min-width: ${size.laptopM}){
    left: calc(50% - 175px);
  }
`;

export default { Wrapper };
